export const DESTINATION_TYPES_CONSTANTS = {
  announcement: 'a',
  event: 'e',
  timepoll: 'tp',
  signUp: 'su'
}



// WEBPACK FOOTER //
// ./src/constants.js